// frontend/src/components/ui/placa-input.jsx
import React, { useState } from 'react';
import { Input } from './input';
import { Button } from './button';
import { Loader2, Search } from 'lucide-react';
import api from '../../api';
import { formatPlaca, currencyStringToNumber } from '../../utils/formatters';

export function PlacaInput({ onChange, onDataFound, ...props }) {
  const [placa, setPlaca] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const formatted = formatPlaca(e.target.value);
    setPlaca(formatted);
    setError(null);
    
    if (onChange) {
      onChange(formatted);
    }
  };

  const consultarPlaca = async () => {
    if (placa.length < 7) {
      setError('Digite uma placa válida');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await api.get(`/placafipe/consulta/${placa}`);
      
      if (response.data.success) {
        console.log('Dados do veículo encontrados:', response.data);
        
        // Extrai os dados veiculares
        const { veiculo, fipe } = response.data.data;
        
        // Prepara os dados para preencher o formulário
        const vehicleData = {
          placa: veiculo.placa,
          placaMercosul: veiculo.placaMercosul,
          infoTecnica: {
            marca: veiculo.marca,
            modelo: veiculo.modelo,
            versao: veiculo.importado === "Não" ? "Nacional" : "Importado",
            anoFabricacao: veiculo.ano?.split('/')?.[0] || veiculo.ano,
            anoModelo: veiculo.anoModelo || veiculo.ano?.split('/')?.[1],
            cor: veiculo.cor,
            combustivel: veiculo.combustivel,
            cilindrada: veiculo.cilindrada,
            potencia: veiculo.potencia,
            chassi: veiculo.chassi,
            renavam: veiculo.renavam
          },
          comercial: {
            valorFipe: fipe.valor ? currencyStringToNumber(fipe.valor) : null
          }
        };

        // Notifica o componente pai sobre os dados encontrados
        if (onDataFound) {
          onDataFound(vehicleData);
        }
      } else {
        setError(response.data.message || 'Não foi possível encontrar informações para esta placa.');
      }
    } catch (error) {
      console.error('Erro ao consultar placa:', error);
      setError('Ocorreu um erro ao consultar a placa. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Input
          value={placa}
          onChange={handleChange}
          placeholder="Digite a placa"
          maxLength={7}
          className="uppercase"
          {...props}
        />
        <Button 
          type="button" 
          onClick={consultarPlaca}
          disabled={isLoading || placa.length < 7}
          className="whitespace-nowrap"
          variant="default"
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Consultando...
            </>
          ) : (
            <>
              <Search className="mr-2 h-4 w-4" />
              Consultar
            </>
          )}
        </Button>
      </div>
      {error && (
        <p className="text-sm text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
}
